import type { TChainBlock } from "@/zapi-frontend/shared/types/contentBlocks";
import type { TValueChain } from "../ValueChainIsland/chainTypes";
import { ChainCanvas, WhoHoldsSection } from "../ValueChainIsland/ValueChainIsland";
// The chain block reuses the standalone value-chain feature's renderers; the block's
// "case" owner maps onto the feature's "ours" vocabulary. The block label is not
// rendered: the hosting section's title already carries it.
const toValueChain = (block: TChainBlock): TValueChain => ({
  label: block.label ?? "",
  intent: "",
  stages: block.stages.map((stage) => ({
    key: stage.key,
    label: stage.label,
    owner: stage.owner === "case" ? "ours" : stage.owner,
    heldBy: stage.heldBy ?? undefined,
    annotations: stage.annotations
  })),
  positions: block.positions.map((position) => ({
    kind: position.kind,
    label: position.label,
    stages: position.stages,
    note: position.note ?? undefined
  }))
});

export function ChainBlock({ block }: { block: TChainBlock }) {
  if (block.stages.length === 0) return null;
  const chain = toValueChain(block);

  return (
    <figure className="flex min-w-0 flex-col gap-5">
      <ChainCanvas chain={chain} />
      <WhoHoldsSection chain={chain} />
    </figure>
  );
}
